"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPECIAL_EFFECT_IDS = exports.EffectCategories = exports.END_TRIGGER_TYPES = exports.CULMINATING_MOMENT_SCREEN_COUNTDOWN_COMPLETE_SRCS = exports.CULMINATING_MOMENT_PRE_COUNT_UP_SRCS = exports.CULMINATING_MOMENT_INPUT_DECISION_SRCS = exports.CULMINATING_MOMENT_DECISIONS_INPUTTED_SRCS = exports.CULMINATING_MOMENT_COUNT_UP_SRCS = exports.CULMINATING_MOMENT_COUNT_UP_BEGIN_SRCS = exports.AMBIANCE_TYPE_LIGHT = exports.AMBIANCE_TYPE_EFFECT = exports.AMBIANCE_IDS = void 0;
exports.getAmbianceEffect = getAmbianceEffect;
exports.getSortedLightingEffects = getSortedLightingEffects;
exports.getSpecialEffect = getSpecialEffect;
exports.getSpecialEffectsByCategory = getSpecialEffectsByCategory;
exports.getVisibleSpecialEffects = getVisibleSpecialEffects;
exports.isAmbianceEffectId = isAmbianceEffectId;
exports.isFlashingAmbiance = isFlashingAmbiance;
exports.isSpecialEffectId = isSpecialEffectId;
var _specialEffectLighting = require("./specialEffectLighting");
var _lightStyles = require("./lightStyles");
const END_TRIGGER_TYPES = exports.END_TRIGGER_TYPES = {
  AUDIO: 'AUDIO',
  ALERT: 'ALERT',
  LIGHTS: 'LIGHTS'
};
const AMBIANCE_IDS = exports.AMBIANCE_IDS = {
  NONE: 'NONE',
  BLUE: 'BLUE',
  WHITE: 'WHITE',
  STEALTH: 'STEALTH',
  RED: 'RED',
  RED_ALERT: 'RED_ALERT',
  DEEP_RED_ALERT: 'DEEP_RED_ALERT',
  ALERT_LIGHTS_ONLY: 'ALERT_LIGHTS_ONLY'
};
const SPECIAL_EFFECT_IDS = exports.SPECIAL_EFFECT_IDS = {
  ACCESSING: 'ACCESSING',
  BEEP_COMPUTER: 'BEEP_COMPUTER',
  BEEP_HIGH: 'BEEP_HIGH',
  CALL_CONNECT: 'CALL_CONNECT',
  CALL_DISCONNECT: 'CALL_DISCONNECT',
  CAUGHT: 'CAUGHT',
  COMPUTER_BEEP: 'COMPUTER_BEEP',
  COMPUTER_STARTUP: 'COMPUTER_STARTUP',
  EXPLOSION: 'EXPLOSION',
  FLICKER: 'FLICKER',
  LASER: 'LASER',
  LONG_EXPLOSION: 'LONG_EXPLOSION',
  EXPLOSION_CUT_OFF: 'EXPLOSION_CUT_OFF',
  MAJOR_ERROR: 'MAJOR_ERROR',
  METAL_CREAK: 'METAL_CREAK',
  METALLIC_THUD: 'METALLIC_THUD',
  PHASER_CANNON: 'PHASER_CANNON',
  PHONE_RING: 'PHONE_RING',
  POWER_DOWN: 'POWER_DOWN',
  POWER_UP: 'POWER_UP',
  PROBE: 'PROBE',
  SCANNER: 'SCANNER',
  SERVO: 'SERVO',
  SHIP_PASS_BY: 'SHIP_PASS_BY',
  STAND_DOWN: 'STAND_DOWN',
  THRUSTERS: 'THRUSTERS',
  TORPEDO: 'TORPEDO',
  TRACTOR_BEAM: 'TRACTOR_BEAM',
  TRANSPORT: 'TRANSPORT',
  WARP_JUMP: 'WARP_JUMP',
  WARP_STOP: 'WARP_STOP',
  CULMINATING_MOMENT_START: 'CULMINATING_MOMENT_START',
  CULMINATING_MOMENT_DELIBERATION: 'CULMINATING_MOMENT_DELIBERATION',
  CULMINATING_MOMENT_TEACHER_CHOICE: 'CULMINATING_MOMENT_TEACHER_CHOICE',
  SHOW_NEW_DISPLAY: 'SHOW_NEW_DISPLAY',
  TYPING: 'TYPING',
  GLITCH_HIGH: 'GLITCH_HIGH',
  SUCCESS_DING: 'SUCCESS_DING',
  SUCCESS_TRUMPETS: 'SUCCESS_TRUMPETS',
  FAIL: 'FAIL',
  RISERS_PULSE_1: 'RISERS_PULSE_1',
  RISERS_PULSE_2: 'RISERS_PULSE_2',
  LEVEL_UP: 'LEVEL_UP',
  APPLAUSE: 'APPLAUSE',
  STATS_INTRO: 'STATS_INTRO',
  MVP_INTRO: 'MVP_INTRO',
  COMPLETION_INTRO: 'COMPLETION_INTRO',
  // End Of Mission Sequence
  EOMS_APPEAR: 'EOMS_APPEAR',
  EOMS_SUCCESS_SPARKLE: 'EOMS_SUCCESS_SPARKLE',
  EOMS_SUCCESS_CLICK: 'EOMS_SUCCESS_CLICK',
  EOMS_COUNT_UP_CLICKS: 'EOMS_COUNT_UP_CLICKS',
  EOMS_SWIPE_HARD: 'EOMS_SWIPE_HARD',
  EOMS_SWIPE_SOFT: 'EOMS_SWIPE_SOFT',
  EOMS_SUCCESS_SUPER_SPARKLE: 'EOMS_SUCCESS_SUPER_SPARKLE',
  EOMS_SUSPENSE: 'EOMS_SUSPENSE',
  EOMS_SUSPENSE_ELECTRIC: 'EOMS_SUSPENSE_ELECTRIC'
};
const HIGH_PRIORITY = 100;
const computerEffects = [SPECIAL_EFFECT_IDS.ACCESSING, SPECIAL_EFFECT_IDS.SCANNER, SPECIAL_EFFECT_IDS.COMPUTER_BEEP, SPECIAL_EFFECT_IDS.MAJOR_ERROR];
const travelEffects = [SPECIAL_EFFECT_IDS.WARP_JUMP, SPECIAL_EFFECT_IDS.WARP_STOP, SPECIAL_EFFECT_IDS.SHIP_PASS_BY, SPECIAL_EFFECT_IDS.THRUSTERS];
const shipFunctions = [SPECIAL_EFFECT_IDS.POWER_UP, SPECIAL_EFFECT_IDS.POWER_DOWN, SPECIAL_EFFECT_IDS.SERVO, SPECIAL_EFFECT_IDS.CAUGHT];
const shipTools = [SPECIAL_EFFECT_IDS.TRANSPORT, SPECIAL_EFFECT_IDS.TRACTOR_BEAM];
const weapons = [SPECIAL_EFFECT_IDS.TORPEDO, SPECIAL_EFFECT_IDS.PHASER_CANNON];
const explosions = [SPECIAL_EFFECT_IDS.EXPLOSION, SPECIAL_EFFECT_IDS.LONG_EXPLOSION];
const soundEffectAWSUrl = 'https://resources-cdn.mission.io/simulations/soundEffects/';
const specialEffects = {
  // Standard special effects
  [SPECIAL_EFFECT_IDS.COMPUTER_BEEP]: {
    id: SPECIAL_EFFECT_IDS.COMPUTER_BEEP,
    name: 'Computer Beep',
    audioSrc: `${soundEffectAWSUrl}Beep1.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.ACCESSING]: {
    id: SPECIAL_EFFECT_IDS.ACCESSING,
    name: 'Accessing',
    audioSrc: `${soundEffectAWSUrl}Accessing1.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.MAJOR_ERROR]: {
    id: SPECIAL_EFFECT_IDS.MAJOR_ERROR,
    name: 'Computer Fail',
    audioSrc: `${soundEffectAWSUrl}Major Error 1.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.EXPLOSION]: {
    id: SPECIAL_EFFECT_IDS.EXPLOSION,
    name: 'Explosion',
    audioSrc: `${soundEffectAWSUrl}Explosion Far Away.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.EXPLOSION,
    priority: HIGH_PRIORITY
  },
  [SPECIAL_EFFECT_IDS.LONG_EXPLOSION]: {
    id: SPECIAL_EFFECT_IDS.LONG_EXPLOSION,
    name: 'Long Explosion',
    audioSrc: `${soundEffectAWSUrl}Explosion Long.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.LONG_EXPLOSION,
    priority: HIGH_PRIORITY
  },
  [SPECIAL_EFFECT_IDS.EXPLOSION_CUT_OFF]: {
    id: SPECIAL_EFFECT_IDS.EXPLOSION_CUT_OFF,
    name: 'Explosion Cut Off',
    audioSrc: `${soundEffectAWSUrl}Explosion-Cut-Off.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.EXPLOSION_CUT_OFF,
    priority: HIGH_PRIORITY
  },
  [SPECIAL_EFFECT_IDS.FLICKER]: {
    id: SPECIAL_EFFECT_IDS.FLICKER,
    name: 'Flicker',
    endTrigger: END_TRIGGER_TYPES.LIGHTS,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.FLICKER
  },
  [SPECIAL_EFFECT_IDS.SCANNER]: {
    id: SPECIAL_EFFECT_IDS.SCANNER,
    name: 'Scanner',
    audioSrc: `${soundEffectAWSUrl}Scanned.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.SCANNER
  },
  [SPECIAL_EFFECT_IDS.SERVO]: {
    id: SPECIAL_EFFECT_IDS.SERVO,
    name: 'Servo',
    audioSrc: `${soundEffectAWSUrl}Servo Movement.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.CAUGHT]: {
    id: SPECIAL_EFFECT_IDS.CAUGHT,
    name: 'Caught',
    audioSrc: `${soundEffectAWSUrl}Caught.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.CAUGHT
  },
  [SPECIAL_EFFECT_IDS.TRANSPORT]: {
    id: SPECIAL_EFFECT_IDS.TRANSPORT,
    name: 'Transport',
    audioSrc: `${soundEffectAWSUrl}Transport.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.TRANSPORT
  },
  [SPECIAL_EFFECT_IDS.PROBE]: {
    id: SPECIAL_EFFECT_IDS.PROBE,
    name: 'Probe',
    audioSrc: `${soundEffectAWSUrl}Probe Fired.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.PROBE
  },
  [SPECIAL_EFFECT_IDS.TRACTOR_BEAM]: {
    id: SPECIAL_EFFECT_IDS.TRACTOR_BEAM,
    name: 'Tractor Beam',
    audioSrc: `${soundEffectAWSUrl}Tractor Beam.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.TRACTOR_BEAM
  },
  [SPECIAL_EFFECT_IDS.SHIP_PASS_BY]: {
    id: SPECIAL_EFFECT_IDS.SHIP_PASS_BY,
    name: 'Ship Pass-by',
    audioSrc: `${soundEffectAWSUrl}Ship Passby.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.SHIP_PASS_BY
  },
  [SPECIAL_EFFECT_IDS.METAL_CREAK]: {
    id: SPECIAL_EFFECT_IDS.METAL_CREAK,
    name: 'Metal Creak',
    audioSrc: `${soundEffectAWSUrl}Metal Creaking.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.METALLIC_THUD]: {
    id: SPECIAL_EFFECT_IDS.METALLIC_THUD,
    name: 'Metallic Thud',
    audioSrc: `${soundEffectAWSUrl}Metallic Thud.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.WARP_JUMP]: {
    id: SPECIAL_EFFECT_IDS.WARP_JUMP,
    name: 'Warp Jump',
    audioSrc: `${soundEffectAWSUrl}warp_jump.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.WARP_JUMP
  },
  [SPECIAL_EFFECT_IDS.WARP_STOP]: {
    id: SPECIAL_EFFECT_IDS.WARP_STOP,
    name: 'Warp Stop',
    audioSrc: `${soundEffectAWSUrl}warp_stop.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.WARP_STOP
  },
  [SPECIAL_EFFECT_IDS.THRUSTERS]: {
    id: SPECIAL_EFFECT_IDS.THRUSTERS,
    name: 'Thrusters',
    audioSrc: `${soundEffectAWSUrl}Thrusters.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.POWER_UP]: {
    id: SPECIAL_EFFECT_IDS.POWER_UP,
    name: 'Power Up',
    audioSrc: `${soundEffectAWSUrl}Shield Power Up.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.POWER_UP
  },
  [SPECIAL_EFFECT_IDS.POWER_DOWN]: {
    id: SPECIAL_EFFECT_IDS.POWER_DOWN,
    name: 'Power Down',
    audioSrc: `${soundEffectAWSUrl}Power Down.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.POWER_DOWN
  },
  [SPECIAL_EFFECT_IDS.TORPEDO]: {
    id: SPECIAL_EFFECT_IDS.TORPEDO,
    name: 'Torpedo',
    audioSrc: `${soundEffectAWSUrl}Torpedo Fired.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.TORPEDO
  },
  [SPECIAL_EFFECT_IDS.PHASER_CANNON]: {
    id: SPECIAL_EFFECT_IDS.PHASER_CANNON,
    name: 'Phaser Cannon',
    audioSrc: `${soundEffectAWSUrl}Phaser Cannons.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.PHASER_CANNON
  },
  [SPECIAL_EFFECT_IDS.LASER]: {
    id: SPECIAL_EFFECT_IDS.LASER,
    name: 'Laser',
    audioSrc: `${soundEffectAWSUrl}Phasers Large.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  }
};
const nonVisibleSpecialEffects = {
  [SPECIAL_EFFECT_IDS.BEEP_COMPUTER]: {
    id: SPECIAL_EFFECT_IDS.BEEP_COMPUTER,
    name: 'Beep Computer',
    audioSrc: `${soundEffectAWSUrl}Beep_Computer.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.CULMINATING_MOMENT_START]: {
    id: SPECIAL_EFFECT_IDS.CULMINATING_MOMENT_START,
    name: 'Culminating Moment Start',
    endTrigger: END_TRIGGER_TYPES.LIGHTS,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.CULMINATING_MOMENT_START
  },
  [SPECIAL_EFFECT_IDS.CULMINATING_MOMENT_DELIBERATION]: {
    id: SPECIAL_EFFECT_IDS.CULMINATING_MOMENT_DELIBERATION,
    name: 'Culminating Moment Deliberation',
    endTrigger: END_TRIGGER_TYPES.LIGHTS,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.CULMINATING_MOMENT_DELIBERATION,
    loop: true
  },
  [SPECIAL_EFFECT_IDS.CULMINATING_MOMENT_TEACHER_CHOICE]: {
    id: SPECIAL_EFFECT_IDS.CULMINATING_MOMENT_TEACHER_CHOICE,
    name: 'Culminating Moment Teacher Choice',
    audioSrc: `${soundEffectAWSUrl}CULMINATING_MOMENT_TEACHER_CHOICE.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.CULMINATING_MOMENT_TEACHER_CHOICE,
    loop: true
  },
  [SPECIAL_EFFECT_IDS.COMPUTER_STARTUP]: {
    id: SPECIAL_EFFECT_IDS.COMPUTER_STARTUP,
    name: 'Computer Startup',
    audioSrc: `${soundEffectAWSUrl}Computer Startup.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.COMPUTER_STARTUP
  },
  [SPECIAL_EFFECT_IDS.BEEP_HIGH]: {
    id: SPECIAL_EFFECT_IDS.BEEP_HIGH,
    name: 'Beep High',
    audioSrc: `${soundEffectAWSUrl}Beep_High.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.BEEP_HIGH
  },
  [SPECIAL_EFFECT_IDS.STAND_DOWN]: {
    id: SPECIAL_EFFECT_IDS.STAND_DOWN,
    name: 'Stand Down',
    audioSrc: `${soundEffectAWSUrl}Stand Down.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.PHONE_RING]: {
    id: SPECIAL_EFFECT_IDS.PHONE_RING,
    name: 'Phone Ring',
    audioSrc: `${soundEffectAWSUrl}Call Incoming.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.CALL_CONNECT]: {
    id: SPECIAL_EFFECT_IDS.CALL_CONNECT,
    name: 'Answer Phone',
    audioSrc: `${soundEffectAWSUrl}Call Connect.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.CALL_DISCONNECT]: {
    id: SPECIAL_EFFECT_IDS.CALL_DISCONNECT,
    name: 'Hang up',
    audioSrc: `${soundEffectAWSUrl}Call Disconnect.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.TYPING]: {
    id: SPECIAL_EFFECT_IDS.TYPING,
    name: 'Typing',
    audioSrc: `${soundEffectAWSUrl}TYPING.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.SHOW_NEW_DISPLAY]: {
    id: SPECIAL_EFFECT_IDS.SHOW_NEW_DISPLAY,
    name: 'New Display',
    audioSrc: `${soundEffectAWSUrl}IMAGE APPEAR.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.GLITCH_HIGH]: {
    id: SPECIAL_EFFECT_IDS.GLITCH_HIGH,
    name: 'Glitch High',
    audioSrc: `${soundEffectAWSUrl}Glitch_High_09.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.FAIL]: {
    id: SPECIAL_EFFECT_IDS.FAIL,
    name: 'Fail',
    audioSrc: `${soundEffectAWSUrl}FAIL SOUND EFFECT.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.LEVEL_UP]: {
    id: SPECIAL_EFFECT_IDS.LEVEL_UP,
    name: 'Level up',
    audioSrc: `${soundEffectAWSUrl}Level-up-sound-effect.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.RISERS_PULSE_1]: {
    id: SPECIAL_EFFECT_IDS.RISERS_PULSE_1,
    name: 'Riser pulse 1',
    audioSrc: `${soundEffectAWSUrl}Risers_Pulse_03.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.RISERS_PULSE_2]: {
    id: SPECIAL_EFFECT_IDS.RISERS_PULSE_2,
    name: 'Riser pulse 2',
    audioSrc: `${soundEffectAWSUrl}Risers_Pulse_04.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.SUCCESS_DING]: {
    id: SPECIAL_EFFECT_IDS.SUCCESS_DING,
    name: 'Success Ding',
    audioSrc: `${soundEffectAWSUrl}SuccessDing.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.SUCCESS_TRUMPETS]: {
    id: SPECIAL_EFFECT_IDS.SUCCESS_TRUMPETS,
    name: 'Success Trumpets',
    audioSrc: `${soundEffectAWSUrl}SuccessTrumpets.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.APPLAUSE]: {
    id: SPECIAL_EFFECT_IDS.APPLAUSE,
    name: 'Applause',
    audioSrc: `${soundEffectAWSUrl}Applause.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.STATS_INTRO]: {
    id: SPECIAL_EFFECT_IDS.STATS_INTRO,
    name: 'Stats Intro',
    audioSrc: `${soundEffectAWSUrl}End of Mission (Collecting Results).mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.COMPLETION_INTRO]: {
    id: SPECIAL_EFFECT_IDS.COMPLETION_INTRO,
    name: 'Completion Intro',
    audioSrc: `${soundEffectAWSUrl}Now Determining Mission Success.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.MVP_INTRO]: {
    id: SPECIAL_EFFECT_IDS.MVP_INTRO,
    name: 'MVP Intro',
    audioSrc: `${soundEffectAWSUrl}Now Displaying MVPs.mp3`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  // End Of Mission Sequence
  [SPECIAL_EFFECT_IDS.EOMS_APPEAR]: {
    id: SPECIAL_EFFECT_IDS.EOMS_APPEAR,
    name: 'EOMS Card Appear',
    audioSrc: `${soundEffectAWSUrl}appear.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.EOMS_SUCCESS_SPARKLE]: {
    id: SPECIAL_EFFECT_IDS.EOMS_SUCCESS_SPARKLE,
    name: 'EOMS Success Sparkle',
    audioSrc: `${soundEffectAWSUrl}successSparkle.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.EOMS_SUCCESS_SUPER_SPARKLE]: {
    id: SPECIAL_EFFECT_IDS.EOMS_SUCCESS_SUPER_SPARKLE,
    name: 'EOMS Success Super Sparkle',
    audioSrc: `${soundEffectAWSUrl}successSuperSparkle.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.EOMS_SUCCESS_CLICK]: {
    id: SPECIAL_EFFECT_IDS.EOMS_SUCCESS_CLICK,
    name: 'EOMS Success Click',
    audioSrc: `${soundEffectAWSUrl}successClick.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.EOMS_COUNT_UP_CLICKS]: {
    id: SPECIAL_EFFECT_IDS.EOMS_COUNT_UP_CLICKS,
    name: 'EOMS Count Up CLicks',
    audioSrc: `${soundEffectAWSUrl}countUpClicks.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.EOMS_SWIPE_HARD]: {
    id: SPECIAL_EFFECT_IDS.EOMS_SWIPE_HARD,
    name: 'EOMS Swipe Hard',
    audioSrc: `${soundEffectAWSUrl}swipeHard.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.EOMS_SWIPE_SOFT]: {
    id: SPECIAL_EFFECT_IDS.EOMS_SWIPE_SOFT,
    name: 'EOMS Swipe Soft',
    audioSrc: `${soundEffectAWSUrl}swipeSoft.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.EOMS_SUSPENSE]: {
    id: SPECIAL_EFFECT_IDS.EOMS_SUSPENSE,
    name: 'EOMS Suspense',
    audioSrc: `${soundEffectAWSUrl}suspense.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  },
  [SPECIAL_EFFECT_IDS.EOMS_SUSPENSE_ELECTRIC]: {
    id: SPECIAL_EFFECT_IDS.EOMS_SUSPENSE_ELECTRIC,
    name: 'EOMS Suspense Electric',
    audioSrc: `${soundEffectAWSUrl}suspenseElectric.wav`,
    endTrigger: END_TRIGGER_TYPES.AUDIO
  }
};
const AMBIANCE_TYPE_LIGHT = exports.AMBIANCE_TYPE_LIGHT = 'AMBIANCE_TYPE_LIGHT';
const AMBIANCE_TYPE_EFFECT = exports.AMBIANCE_TYPE_EFFECT = 'AMBIANCE_TYPE_EFFECT';
const ambianceEffects = {
  [AMBIANCE_IDS.NONE]: {
    id: AMBIANCE_IDS.NONE,
    name: 'Not for Display',
    type: AMBIANCE_TYPE_LIGHT,
    lightStyleId: _lightStyles.LIGHT_STYLE_IDS.NONE
  },
  [AMBIANCE_IDS.BLUE]: {
    id: AMBIANCE_IDS.BLUE,
    name: 'Blue',
    type: AMBIANCE_TYPE_LIGHT,
    lightStyleId: _lightStyles.LIGHT_STYLE_IDS.AMBIANCE_BLUE
  },
  [AMBIANCE_IDS.WHITE]: {
    id: AMBIANCE_IDS.WHITE,
    name: 'White',
    type: AMBIANCE_TYPE_LIGHT,
    lightStyleId: _lightStyles.LIGHT_STYLE_IDS.AMBIANCE_WHITE
  },
  [AMBIANCE_IDS.STEALTH]: {
    id: AMBIANCE_IDS.STEALTH,
    name: 'Stealth',
    type: AMBIANCE_TYPE_LIGHT,
    lightStyleId: _lightStyles.LIGHT_STYLE_IDS.AMBIANCE_BLUE_STEALTH
  },
  [AMBIANCE_IDS.RED]: {
    id: AMBIANCE_IDS.RED,
    name: 'Red',
    type: AMBIANCE_TYPE_LIGHT,
    lightStyleId: _lightStyles.LIGHT_STYLE_IDS.AMBIANCE_RED,
    danger: true
  },
  [AMBIANCE_IDS.RED_ALERT]: {
    id: AMBIANCE_IDS.RED_ALERT,
    name: 'Emergency',
    type: AMBIANCE_TYPE_EFFECT,
    audioSrc: `${soundEffectAWSUrl}Red Alert.wav`,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.RED_ALERT,
    endTrigger: END_TRIGGER_TYPES.LIGHTS,
    danger: true,
    flashAlternative: {
      baseLightStyleId: _lightStyles.LIGHT_STYLE_IDS.AMBIANCE_RED,
      endTrigger: END_TRIGGER_TYPES.AUDIO,
      endTriggerDelay: 1000
    }
  },
  [AMBIANCE_IDS.DEEP_RED_ALERT]: {
    id: AMBIANCE_IDS.DEEP_RED_ALERT,
    name: 'Warning',
    type: AMBIANCE_TYPE_EFFECT,
    audioSrc: `${soundEffectAWSUrl}deep_redalert_Short.wav`,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.DEEP_RED_ALERT,
    endTrigger: END_TRIGGER_TYPES.LIGHTS,
    danger: true,
    flashAlternative: {
      baseLightStyleId: _lightStyles.LIGHT_STYLE_IDS.AMBIANCE_RED,
      endTrigger: END_TRIGGER_TYPES.AUDIO,
      endTriggerDelay: 4000
    }
  },
  [AMBIANCE_IDS.ALERT_LIGHTS_ONLY]: {
    id: AMBIANCE_IDS.ALERT_LIGHTS_ONLY,
    name: 'Alert (No Sound)',
    type: AMBIANCE_TYPE_EFFECT,
    lights: _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS.DEEP_RED_ALERT,
    endTrigger: END_TRIGGER_TYPES.LIGHTS,
    danger: true,
    flashAlternative: {
      baseLightStyleId: _lightStyles.LIGHT_STYLE_IDS.AMBIANCE_RED
    }
  }
};
function getVisibleSpecialEffects() {
  return Object.keys(specialEffects).map(effectId => specialEffects[effectId]);
}
const EffectCategories = exports.EffectCategories = {
  COMPUTER: 'COMPUTER',
  TRAVEL: 'TRAVEL',
  SHIP_FUNCTIONS: 'SHIP_FUNCTIONS',
  SHIP_TOOLS: 'SHIP_TOOLS',
  WEAPONS: 'WEAPONS',
  EXPLOSIONS: 'EXPLOSIONS'
};
function getSpecialEffectsByCategory(type) {
  switch (type) {
    case 'COMPUTER':
      return computerEffects.map(effectId => specialEffects[effectId]);
    case 'TRAVEL':
      return travelEffects.map(effectId => specialEffects[effectId]);
    case 'SHIP_FUNCTIONS':
      return shipFunctions.map(effectId => specialEffects[effectId]);
    case 'SHIP_TOOLS':
      return shipTools.map(effectId => specialEffects[effectId]);
    case 'WEAPONS':
      return weapons.map(effectId => specialEffects[effectId]);
    case 'EXPLOSIONS':
      return explosions.map(effectId => specialEffects[effectId]);
    default:
      return [];
  }
}
function getSpecialEffect(effectId) {
  return specialEffects[effectId] || nonVisibleSpecialEffects[effectId];
}
function getSortedLightingEffects(effectId) {
  const effect = getSpecialEffect(effectId) || getAmbianceEffect(effectId);
  if (!effect || !effect.lights) {
    return null;
  }

  // $FlowFixMe I'm sure there's a way to get this to work with flow, but we know it's what we want
  return _specialEffectLighting.sortedSpecialEffectLighting[effect.lights];
}
function getAmbianceEffect(ambianceEffectId) {
  return ambianceEffects[ambianceEffectId];
}
function isAmbianceEffectId(ambianceEffectId) {
  return AMBIANCE_IDS.hasOwnProperty(ambianceEffectId);
}
function isSpecialEffectId(effectId) {
  return isAmbianceEffectId(effectId) || Boolean(getSpecialEffect(effectId));
}
function isFlashingAmbiance(ambianceEffectId) {
  const effect = getAmbianceEffect(ambianceEffectId);
  if (!effect) {
    return false;
  }
  return effect.type === AMBIANCE_TYPE_EFFECT && !!effect.flashAlternative;
}
const CULMINATING_MOMENT_INPUT_DECISION_SRCS = exports.CULMINATING_MOMENT_INPUT_DECISION_SRCS = [`${soundEffectAWSUrl}Culminating-Moment/input-decision.mp3`];
const CULMINATING_MOMENT_PRE_COUNT_UP_SRCS = exports.CULMINATING_MOMENT_PRE_COUNT_UP_SRCS = [`${soundEffectAWSUrl}Culminating-Moment/pre-tally.mp3`];
const CULMINATING_MOMENT_DECISIONS_INPUTTED_SRCS = exports.CULMINATING_MOMENT_DECISIONS_INPUTTED_SRCS = {
  jr: [`${soundEffectAWSUrl}Culminating-Moment/jr/decision-inputted-1.wav`],
  jrPlus: [`${soundEffectAWSUrl}Culminating-Moment/jr-plus/decision-inputted-1.wav`]
};
const CULMINATING_MOMENT_SCREEN_COUNTDOWN_COMPLETE_SRCS = exports.CULMINATING_MOMENT_SCREEN_COUNTDOWN_COMPLETE_SRCS = [`${soundEffectAWSUrl}Culminating-Moment/countdown-complete.wav`];
const CULMINATING_MOMENT_COUNT_UP_BEGIN_SRCS = exports.CULMINATING_MOMENT_COUNT_UP_BEGIN_SRCS = [`${soundEffectAWSUrl}Culminating-Moment/begin-tallying-up.wav`];
const CULMINATING_MOMENT_COUNT_UP_SRCS = exports.CULMINATING_MOMENT_COUNT_UP_SRCS = [`${soundEffectAWSUrl}Culminating-Moment/tallying-up.wav`];